import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var Subscription = Class.create({
  	initialize: function() {
	},
    getSubscription: function(callback) {
		var url = "user/subscription";
		var data = server.getData(url, null, true, "GET");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
                callback(false);
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
    },
    updateSubscription: function(id, callback) {
        var url = "user/subscription";
        var params = {
            subscription_id: id
        }
		var data = server.getData(url, params, true, "PUT");
		data
		.done(function(response){
			callback(response);
		})
		.fail(function(e){
            if (e.status == 404) {
                callback(false);
            } else {
                modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
            }
		});
    }

});

export let subscription = new Subscription();


// WEBPACK FOOTER //
// app/core/controllers/Subscription.js